/**
 * ローディングアニメーション管理モジュール
 * 初回訪問時のローディング演出とロゴアニメーションを制御
 */

import { gsap } from 'gsap';
import { LOADING_CONFIG } from './config.js';

/**
 * ローディングアニメーションのセットアップと実行
 * @returns {Promise} アニメーション完了後にresolveされるPromise
 */
export function setupLoadingAnimation() {
  const cir = document.querySelectorAll('.cir');
  if (cir.length === 0) return Promise.resolve();

  // ローカルストレージから最後の表示時刻を取得
  const lastShown = localStorage.getItem(LOADING_CONFIG.storageKey);
  const now = Date.now();

  // 前回の表示から24時間経過していない場合はスキップ
  if (lastShown && now - parseInt(lastShown) < LOADING_CONFIG.showInterval) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const tl = gsap.timeline({
      onComplete: () => {
        // アニメーション完了時に現在時刻を保存
        localStorage.setItem(LOADING_CONFIG.storageKey, now.toString());
        resolve();
      },
    });

    tl.set('.cir', {
      scale: 0,
      transformOrigin: 'center',
    })
      .set('#logo', {
        scale: 0.47,
        transformOrigin: 'center',
        opacity: 0,
      })
      .to('.cir', {
        ease: 'back.out(3)',
        duration: 4,
        scale: gsap.utils.distribute({
          base: 1,
          amount: 3,
          from: 'end',
        }),
        stagger: {
          each: 0.4,
        },
      })
      .to(
        '#logo',
        {
          scale: 0.5,
          transformOrigin: 'center',
          opacity: 1,
          duration: 2,
        },
        '-=1.5'
      )
      .to('.logo_container', {
        autoAlpha: 0,
        duration: 0.5,
        onComplete: () => {
          gsap.set('.logo_container', { display: 'none' });
        },
      });
  });
} 
